import React from "react";
import { DataLoaderOption, StandaloneSyncSystem } from "../../api/datasystems";
import { DataLoaderSystemComponent } from "./DataLoaderSystem";
import { ConfigurationSection } from "./SourceCard";

interface StandaloneSyncSystemCardProps {
  syncSystem: StandaloneSyncSystem;
  syncSystemOptions: DataLoaderOption[];
}

export function StandaloneSyncSystemCard(
  props: Readonly<StandaloneSyncSystemCardProps>
) {
  return (
    <ConfigurationSection title="Connection settings">
      <DataLoaderSystemComponent
        name={props.syncSystem.name}
        type={props.syncSystem.system_type}
        id={props.syncSystem.id}
        configRevisionId={props.syncSystem.config_revision_id}
        existing={true}
        disableTypeEdit={true}
        hideHeading={true}
        onDataLoaderSystemChange={() => {}}
        dataLoaderOptions={props.syncSystemOptions}
      />
    </ConfigurationSection>
  );
}
